import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "aldoc" }
const _hoisted_2 = {
  class: "sui-card sui-card--flush",
  "data-tour": "admin-legal-docs-list"
}
const _hoisted_3 = {
  class: "sui-toolbar",
  "data-tour": "admin-legal-docs-toolbar"
}
const _hoisted_4 = { class: "aldoc__filter" }
const _hoisted_5 = {
  key: 0,
  class: "aldoc__error"
}
const _hoisted_6 = {
  key: 1,
  class: "aldoc__table-wrap"
}
const _hoisted_7 = { class: "aldoc__table" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 2,
  class: "aldoc__empty"
}
const _hoisted_10 = {
  key: 0,
  class: "aldoc__modal",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_11 = {
  class: "aldoc__modal-panel",
  "data-tour": "admin-legal-docs-editor"
}
const _hoisted_12 = { class: "aldoc__form" }
const _hoisted_13 = ["readonly"]
const _hoisted_14 = ["readonly"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "is-full" }
const _hoisted_17 = { class: "is-full" }
const _hoisted_18 = { class: "aldoc__check" }
const _hoisted_19 = ["disabled"]

import { onMounted, reactive, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  createAdminLegalDoc,
  fetchAdminLegalDocs,
  updateAdminLegalDoc,
  type LegalDoc,
} from '@/api/admin'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLegalDocsPage',
  setup(__props) {

const docs = ref<LegalDoc[]>([])
const audience = ref('')
const loading = ref(false)
const saving = ref(false)
const errorMessage = ref('')
const modalOpen = ref(false)
const editing = ref(false)

const form = reactive({
  code: '',
  version: '',
  title: '',
  body: '',
  audience: 'SELLER' as string,
  kind: 'TERMS' as 'TERMS' | 'CONTRACT',
  effective: new Date().toISOString().slice(0, 10),
  active: true,
})

function audienceLabel(value: string) {
  if (value === 'SELLER') return '판매업체'
  if (value === 'MEMBER') return '일반회원'
  return '공통'
}

function kindLabel(value?: string) {
  return value === 'CONTRACT' ? '계약서' : '이용약관'
}

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    docs.value = await fetchAdminLegalDocs(audience.value)
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '약관을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

function openCreate() {
  editing.value = false
  form.code = 'seller_service'
  form.version = new Date().toISOString().slice(0, 10).replace(/-/g, '.')
  form.title = ''
  form.body = ''
  form.audience = 'SELLER'
  form.kind = 'TERMS'
  form.effective = new Date().toISOString().slice(0, 10)
  form.active = true
  modalOpen.value = true
}

function openEdit(doc: LegalDoc) {
  editing.value = true
  form.code = doc.code
  form.version = doc.version
  form.title = doc.title
  form.body = doc.body
  form.audience = doc.audience
  form.kind = doc.kind === 'CONTRACT' ? 'CONTRACT' : 'TERMS'
  form.effective = doc.effective
  form.active = doc.active
  modalOpen.value = true
}

function closeModal() {
  modalOpen.value = false
}

async function onSave() {
  if (!form.code || !form.version || !form.title || !form.body) {
    window.alert('코드·버전·제목·본문을 입력해 주세요.')
    return
  }
  saving.value = true
  try {
    if (editing.value) {
      await updateAdminLegalDoc(form.code, form.version, {
        title: form.title,
        body: form.body,
        audience: form.audience,
        kind: form.kind,
        effective: form.effective,
        active: form.active,
      })
    } else {
      await createAdminLegalDoc({
        code: form.code,
        version: form.version,
        title: form.title,
        body: form.body,
        audience: form.audience,
        kind: form.kind,
        effective: form.effective,
        active: form.active,
      })
    }
    modalOpen.value = false
    await load()
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '저장에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

onMounted(load)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "aldoc__lead" }, " 판매업체 온보딩·일반회원 이용약관과 공급계약서의 최신 본문을 관리합니다. 구분(이용약관/계약서)과 버전을 활성화하면 온보딩 화면에 바로 반영됩니다. ", -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("strong", null, "약관 목록", -1)),
        _createElementVNode("label", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "대상", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((audience).value = $event)),
            onChange: load
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "" }, "전체", -1),
            _createElementVNode("option", { value: "SELLER" }, "판매업체", -1),
            _createElementVNode("option", { value: "MEMBER" }, "일반회원", -1),
            _createElementVNode("option", { value: "ALL" }, "공통", -1)
          ]))], 544), [
            [_vModelSelect, audience.value]
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn sui-btn--primary",
          "data-tour": "admin-legal-docs-create",
          onClick: openCreate
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-plus",
            size: 16
          }),
          _cache[11] || (_cache[11] = _createTextVNode(" 새 버전 ", -1))
        ])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      (docs.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "코드"),
                  _createElementVNode("th", null, "버전"),
                  _createElementVNode("th", null, "제목"),
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", null, "대상"),
                  _createElementVNode("th", null, "시행일"),
                  _createElementVNode("th", null, "상태"),
                  _createElementVNode("th")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(docs.value, (doc) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${doc.code}-${doc.version}`
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("code", null, _toDisplayString(doc.code), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(doc.version), 1),
                    _createElementVNode("td", null, _toDisplayString(doc.title), 1),
                    _createElementVNode("td", null, _toDisplayString(kindLabel(doc.kind)), 1),
                    _createElementVNode("td", null, _toDisplayString(audienceLabel(doc.audience)), 1),
                    _createElementVNode("td", null, _toDisplayString(doc.effective), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", doc.active ? 'sui-badge--green' : 'sui-badge--gray'])
                      }, _toDisplayString(doc.active ? '활성' : '비활성'), 3)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sui-btn sui-btn--sm",
                        onClick: ($event: any) => (openEdit(doc))
                      }, "편집", 8, _hoisted_8)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (!loading.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "등록된 약관이 없습니다."))
          : _createCommentVNode("", true)
    ]),
    (modalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "aldoc__modal-backdrop",
            onClick: closeModal
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("header", null, [
              _createElementVNode("h2", null, _toDisplayString(editing.value ? '약관 편집' : '약관 새 버전'), 1),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--sm",
                onClick: closeModal
              }, "닫기")
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", null, [
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "코드", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.code) = $event)),
                  readonly: editing.value,
                  placeholder: "예: seller_service"
                }, null, 8, _hoisted_13), [
                  [
                    _vModelText,
                    form.code,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "버전", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.version) = $event)),
                  readonly: editing.value,
                  placeholder: "예: 2026.08.10"
                }, null, 8, _hoisted_14), [
                  [
                    _vModelText,
                    form.version,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "대상", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.audience) = $event)),
                  disabled: editing.value
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("option", { value: "SELLER" }, "판매업체", -1),
                  _createElementVNode("option", { value: "MEMBER" }, "일반회원", -1),
                  _createElementVNode("option", { value: "ALL" }, "공통", -1)
                ]))], 8, _hoisted_15), [
                  [_vModelSelect, form.audience]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[20] || (_cache[20] = _createElementVNode("span", null, "구분", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.kind) = $event))
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("option", { value: "TERMS" }, "이용약관", -1),
                  _createElementVNode("option", { value: "CONTRACT" }, "계약서", -1)
                ]))], 512), [
                  [_vModelSelect, form.kind]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "시행일", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.effective) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, form.effective]
                ])
              ]),
              _createElementVNode("label", _hoisted_16, [
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "제목", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.title) = $event)),
                  maxlength: "200"
                }, null, 512), [
                  [
                    _vModelText,
                    form.title,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("label", _hoisted_17, [
                _cache[23] || (_cache[23] = _createElementVNode("span", null, "본문", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.body) = $event)),
                  rows: "16"
                }, null, 512), [
                  [_vModelText, form.body]
                ])
              ]),
              _createElementVNode("label", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.active) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, form.active]
                ]),
                _cache[24] || (_cache[24] = _createTextVNode(" 이 버전을 활성으로 사용 ", -1))
              ])
            ]),
            _createElementVNode("footer", null, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeModal
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn sui-btn--primary",
                disabled: saving.value,
                onClick: onSave
              }, _toDisplayString(saving.value ? '저장 중…' : '저장'), 9, _hoisted_19)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})